import { IconButton, IconButtonProps } from "@mui/material";
import React from "react";

const StyledButton: React.FC<IconButtonProps> = ({ children, sx, ...props }) => (
  <IconButton
    {...props}
    sx={{
      ...sx,
      ...{
        color: "#596375",
        borderRadius: "8px",
        padding: "7px",
        boxShadow: "0 1px 2px 0 rgba(9, 25, 72, 0.06)",
        border: "1px solid #E0E4EE",
        minWidth: "0",
        textTransform: "none",
        fontSize: "14px",
        lineHeight: "20px",
        "&:hover": {
          color: "#596375",
          boxShadow: "0 1px 2px 0 rgba(9, 25, 72, 0.06)",
          border: "1px solid #E0E4EE",
        },
        "& .MuiButton-startIcon": {
          marginRight: "6px",
        },
      },
    }}
  >
    {children}
  </IconButton>
);

export default StyledButton; 